const bookPage = (state = 0, action) => {
    switch(action.type) {
        case 'bookPage':
            return action.payload;
        default:
            return state;
    }
}

export default bookPage;